import { FC } from 'react';
import { i18n } from '../../../translate/i18n';
import { Input } from '../../Input/Input';

interface TableSearchProps {
    search: string;
    onSearchChange: (search: string) => void;
    onSearchSubmit: () => void;
    pageSize: number;
    onPageSizeChange: (pageSize: number) => void;
    pageSizeOptions?: number[];
    searchPlaceholder?: string;
    disabled?: boolean;
    clearSearch: () => void
}

export const TableSearch: FC<TableSearchProps> = ({
    search,
    onSearchChange,
    onSearchSubmit,
    pageSize,
    onPageSizeChange,
    pageSizeOptions = [10, 25, 50, 100],
    searchPlaceholder,
    disabled = false,
    clearSearch,
}) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            onSearchSubmit();
        }
    };

    return (
        <div className='d-flex justify-content-between align-items-start w-100'>
            {/* Seletor de itens por página */}
            <div className='col-1'>
                <Input
                    value={pageSize}
                    options={pageSizeOptions.map(size => ({ value: size, select: size }))}
                    inputAttr={{
                        type: 'select',
                        name: 'select',
                    }}
                    change={async (value: number) => {
                        onPageSizeChange(value);
                    }}
                />
            </div>
            {/* Campo de busca */}
            <div className="col-5 col-md-5 col-xl-4">
                <div className="input-group mt-2">
                    <span className="input-group-text bg-white border-end-0">
                        <i className="fas fa-search"></i>
                    </span>
                    <input
                        type="text"
                        className="form-control border-start-0"
                        placeholder={searchPlaceholder || i18n.t('buttons.search') || 'Pesquisar...'}
                        value={search}
                        onChange={(e) => onSearchChange(e.target.value)}
                        onKeyDown={handleKeyDown}
                        onBlur={onSearchSubmit}
                        disabled={disabled}
                        style={{ minWidth: 120 }}
                    />
                    {search && (
                        <button
                            className="btn btn-outline-secondary btn-sm"
                            type="button"
                            onClick={() => {
                                onSearchChange('');
                                clearSearch();
                            }}
                            tabIndex={-1}
                        >
                            <i className="fas fa-times"></i>
                        </button>
                    )}
                </div>
            </div>

        </div>
    );
};
